export default __webpack_public_path__ + "static/media/Shaikh.a52ef5f6.png";